import { render } from "./ContractorWelcome.vue?vue&type=template&id=67aeae90"
import script from "./ContractorWelcome.vue?vue&type=script&lang=js"
export * from "./ContractorWelcome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__